/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, forwardRef } from 'react';
import classnames from 'classnames';
import { getProductionCredits } from 'utils/productions';
import HorizontalScrollIndicators from 'components/uiLibrary/HorizontalScrollIndicators';
import { TP } from 'constants/index';
import { useTranslation } from 'src/i18n';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import { getSectionsVisibility, scrollToSection } from '../utils';
import { SECTION_KEYS } from '../constants';
import classes from './NavigationTabs.module.scss';

const NavigationTabs = forwardRef(({ entity: production, className, isDesktopStubPage }, ref) => {
  const { t } = useTranslation('NS_ENTITY_STUB_PAGE');
  const [selectedTab, setSelectedTab] = useState(null);

  const sectionVisibility = getSectionsVisibility(getProductionCredits(production), production);
  const tabsToShow = [
    {
      title: t(`${TP}.FN_TOP`),
      key: SECTION_KEYS.TOP,
      enabled: true,
      leftIcon: <SpriteIcon icon="arrow_upward" size={12} />,
    },
    {
      title: t(`${TP}.FN_CREDITS_CONTRIBUTIONS`),
      key: SECTION_KEYS.CREDITS,
      enabled: true,
    },
    {
      title: t(`${TP}.FN_PROGRAMS`),
      key: SECTION_KEYS.PROGRAMS,
      enabled: sectionVisibility[SECTION_KEYS.PROGRAMS],
    },
    {
      title: t(`${TP}.m_ARTICLE`),
      key: SECTION_KEYS.REVIEWS,
      enabled: sectionVisibility[SECTION_KEYS.REVIEWS] && isDesktopStubPage,
    },
    {
      title: t(`${TP}.OPERA_ONLINE`),
      key: SECTION_KEYS.VIDEOS,
      enabled: sectionVisibility[SECTION_KEYS.VIDEOS],
    },
    {
      title: t(`${TP}.m_IMAGES`),
      key: SECTION_KEYS.PHOTOS,
      enabled: sectionVisibility[SECTION_KEYS.PHOTOS],
    },
    {
      title: t(`${TP}.m_ABOUT`),
      key: SECTION_KEYS.ABOUT,
      enabled: sectionVisibility[SECTION_KEYS.ABOUT],
    },
    {
      title: t(`${TP}.m_VENUES`),
      key: SECTION_KEYS.VENUES,
      enabled: sectionVisibility[SECTION_KEYS.VENUES],
    },
  ].filter(tab => tab.enabled);

  const scrollTo = sectionKey => {
    scrollToSection(sectionKey);
    setSelectedTab(sectionKey);
  };

  return (
    <nav className={classnames(classes.navigation, className)} ref={ref}>
      <HorizontalScrollIndicators
        triggerSize={0}
        isArrowsEnabled
        styles={{ leftIndicator: classes.scrollIndicator, rightIndicator: classes.scrollIndicator }}
      >
        <ul className={classes.navigation__list}>
          {tabsToShow.map((item, index) => (
            <li
              key={`${item.title}_${index}`}
              className={classnames(classes.navItem, { [classes.selected]: selectedTab === item.key })}
              onClick={() => scrollTo(item.key)}
            >
              {item.leftIcon}
              {item.title}
            </li>
          ))}
        </ul>
      </HorizontalScrollIndicators>
    </nav>
  );
});

export default NavigationTabs;
